import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {Http, Headers, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpClient, HttpParams, HttpRequest, HttpEvent} from '@angular/common/http';
import { ImageuploadService } from './Imageupload.service';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class LoginService {
//postUrl='http://184.168.121.127:81/api/'
//  postUrl='http://192.168.1.20:9003/api/'
//  imageURL="http://192.168.1.20:9003/";

 //postUrl="http://123.176.43.187:98/api/";
 // postUrl='http://42.104.96.36:98/api/'//
// postUrl="http://localhost:9003/api/"; 
//imageURL="http://123.176.43.187:98/";
// imageURL="http://localhost:9003/";
 postUrl='http://123.176.43.187:9003/api/'
  imageURL="http://123.176.43.187:9003/";
//  postUrl='http://localhost:25396/api/'
//  imageURL="http://localhost:25396/";
imagefile:any;
  imagefile1:any;
  imagefile2:any;
  image:any;
  pathData:any;
  uploadPathData: any;
  pagesize: any;
constructor(private toastr:ToastrService,private _http:Http,private http1:HttpClient,public imageservice: ImageuploadService) { 

  }
//
  
//   postFile(fileToUpload: File): Observable<boolean> {
//     const endpoint = 'your-destination-url';
//     const formData: FormData = new FormData();
//     formData.append('fileKey', fileToUpload, fileToUpload.name);
//     return this.http1.post(endpoint, formData, { headers: yourHeadersConfig })
//       .map(() => { return true; })
//       .catch((e) => this.handleError(e));
// }

  // Returns an observable
  upload(file):Observable<any> {
  
      // Create form data
     // const formData = new FormData(); 
        
      // Store form name as "file" with file data
     //     1` formData.append("file", file, file.name);
     // const Weburl = this.postUrl + 'CloudCollabo/UploadFile?file='+formData;
      // Make http post request over api
      // with formData as req
     // return this.FetchData(Weburl);


      const formData: FormData = new FormData();
formData.append('Image', file, file.name);
//formData.append('ComponentId', componentId);
const Weburl = this.postUrl + 'CloudCollabo/UploadImage';
return this.http1.post(Weburl, formData);


      // return this._http.post(this.postUrl+'CloudCollabo/UploadFile', formData)
  }
  // posting the data to the respected Weburl
  
  postdata( Weburl: string, body: string) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    return this._http.post(Weburl, JSON.stringify(body), { headers: headers });
    }
    FetchData(Weburl: string) {
      const params = new URLSearchParams();
      return this._http.get(Weburl, { search: params });
  }
//Authenticating linkdin and accessing oauth token
  GetOauth(body) {
      
    const Weburl = this.postUrl + 'CloudCollabo/GetOauth';
    return this.postdata(Weburl, body);
   }
   //To Retrieving linkdin profile data using access token
   GetProfileData(AccessToken) {
     
     const Weburl = this.postUrl + 'CloudCollabo/GetData?accessToken='+AccessToken;
     return this.FetchData(Weburl);
    }
    //Get User Profile data using access token
    GetEmail(AccessToken) {
      
      const Weburl = this.postUrl + 'CloudCollabo/GetEmail?accessToken='+AccessToken;
      return this.FetchData(Weburl);
     }
	 
  //Retrieving user details based on uertype (Initiator/Colabarator/Admin)
  GetUsers(usertype){
    const Weburl = this.postUrl + 'CloudCollabo/GetUsers?usertype='+usertype;
    return this.FetchData(Weburl);
  
  }
  //Retrieving all users from db
  GetAllUsers(){
    const Weburl = this.postUrl + 'CloudCollabo/GetAllUsers';
    return this.FetchData(Weburl);
  
  }
  //Retrieving subscription plans for user
  GetSubscriptionplans(usertype){
    const Weburl = this.postUrl + 'CloudCollabo/GetSubscriptionplans?usertype='+usertype;
    return this.FetchData(Weburl);
  
  }
  //Saving subscription plans into db
  Saveplans(body: any) {
    const Weburl = this.postUrl + 'CloudCollabo/SavePlans';
    return this.postdata(Weburl, body);
  }
  //Delete plans from db
  Deleteplans(body){
    const Weburl=this.postUrl + 'CloudCollabo/Deleteplans';
    return this.postdata(Weburl,body);
  }
  //Retrieving total users/initiators/vcolabarators .... from db
  GetTotals(){
    const Weburl = this.postUrl + 'CloudCollabo/GetTotals';
    return this.FetchData(Weburl);
  
  }
//Saving user in db
  SaveUsers(body: any) {
    const Weburl = this.postUrl + 'CloudCollabo/InsertUsers';
    return this.postdata(Weburl, body);
  }
  SaveSubscriptions(body:any){
    const Weburl = this.postUrl + 'CloudCollabo/SaveSubcriptions';
    return this.postdata(Weburl, body);
  }
   SaveInvoicePayment(body:any){
    const Weburl = this.postUrl + 'CloudCollabo/SaveInvoicePayments';
    return this.postdata(Weburl, body);
  }
  SendMail(body:any,subject:any,description:any){
    if(description=="loginverify")
    {
      const Weburl = this.postUrl + 'CloudCollabo/SendMail?email='+body+'&subject='+"verify email"+'&body='+"Please click on below accept button to verify....."+'&userid='+subject+'&usertype='+0;
    return this.FetchData(Weburl);
    }
    const Weburl = this.postUrl + 'CloudCollabo/SendMail?email='+body+'&subject='+subject+'&body='+description+'&userid='+0+'&usertype='+0;
    return this.FetchData(Weburl);
  }
    Updateverificationstatus(id,verifyparam)
    {
      const WebUrl=this.postUrl+'CloudCollabo/changeverificationstatus?id='+id+'&verifyparam='+verifyparam;;
      return this.FetchData(WebUrl);
    }
    updateprofilestatus(id,status)
    {
      const WebUrl=this.postUrl+'CloudCollabo/updateprofilestatus?id='+id+'&verifyparam='+status;;
      return this.FetchData(WebUrl);
    }
  
  GetInvoicePayments(){
    const Weburl = this.postUrl + 'CloudCollabo/GetInvoicePayments';
    return this.FetchData(Weburl);
  
  }
  ResetPassword(body:any)
  {
    const Weburl = this.postUrl + 'CloudCollabo/Updatepassword';
    return this.postdata(Weburl, body);
  }
  ApproveInvoice(body:any)
  {
    const Weburl = this.postUrl + 'CloudCollabo/ApproveInvoice';
    return this.postdata(Weburl, body);
  }
   PaidInvoice(body:any)
  {
    const Weburl = this.postUrl + 'CloudCollabo/PaidInvoice';
    return this.postdata(Weburl, body);
  }
  getselectpage(length)
  {
    console.log(length);
    this.pagesize=length;
  }
  getPager(totalItems: number, currentPage: number = 1, pageSize: number=8) {
    pageSize=this.pagesize
    console.log(pageSize)
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);
console.log(totalPages)
    // ensure current page isn't out of range
    if (currentPage < 1) { 
        currentPage = 1; 
    } else if (currentPage > totalPages) { 
        currentPage = totalPages; 
    }
    
    let startPage: number, endPage: number;
    if (totalPages <= 10) {
        // less than 10 total pages so show all
        startPage = 1;
        endPage = totalPages;
    } else {
        // more than 10 total pages so calculate start and end pages
        if (currentPage <= 6) {
            startPage = 1;
            endPage = 10;
        } else if (currentPage + 4 >= totalPages) {
            startPage = totalPages - 9;
            endPage = totalPages;
        } else {
            startPage = currentPage - 5;
            endPage = currentPage + 4;
        }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

    // return object with all pager properties required by the view
    return {
        totalItems: totalItems,
        currentPage: currentPage,
        pageSize: pageSize,
        totalPages: totalPages,
        startPage: startPage,
        endPage: endPage,
        startIndex: startIndex,
        endIndex: endIndex,
        pages: pages
    };
}
  
public GetMenusByUserType(usertypeidparm:string) {
  const Weburl = this.postUrl + 'CloudCollabo/GetMenus?usertypeidparm='+usertypeidparm;
  return this.FetchData(Weburl);
}


Getusertypes(){
  const Weburl = this.postUrl + 'CloudCollabo/Getusertypes';
  return this.FetchData(Weburl);

}


public GetCategorysByParentID(usertype:any,parentidparm:string) {
  const Weburl = this.postUrl + 'CloudCollabo/Getcategories?usertype='+usertype+'&parentidparm='+parentidparm;
  return this.FetchData(Weburl);
}


public Getskills(usertype){
  const Weburl = this.postUrl + 'CloudCollabo/Getskills?usertype='+usertype;
  return this.FetchData(Weburl);

}
public Getservicecharge(usertype){
  const Weburl = this.postUrl + 'CloudCollabo/Getservicecharge?usertype='+usertype;
  return this.FetchData(Weburl);

}
 GetLocations(usertype){
    const Weburl = this.postUrl + 'CloudCollabo/Getlocation?usertype='+usertype;
    return this.FetchData(Weburl);
  
  }

  
  SaveNotifications(body: any) {
    const Weburl = this.postUrl + 'CloudCollabo/InsertNotificatios';
    return this.postdata(Weburl, body);
  }

  SaveLocations(body: any) {
    const Weburl = this.postUrl + 'CloudCollabo/Insertlocation';
    return this.postdata(Weburl, body);
  }
  SaveCountries(body: any) {
    const Weburl = this.postUrl + 'CloudCollabo/InsertCountries';
    return this.postdata(Weburl, body);
  }

  Savestates(body: any) {
    const Weburl = this.postUrl + 'CloudCollabo/InsertStates';
    return this.postdata(Weburl, body);
  }
  DeletechatuserGroup(body:any)
  {
    const WebUrl=this.postUrl+'CloudCollabo/DeleteChatUsergroup';
    return this.postdata(WebUrl, body);
  }
  DeleteUser(body:any)
  {
    const WebUrl=this.postUrl+'CloudCollabo/DeleteUser';
    return this.postdata(WebUrl, body);
  }
  ReactivateUser(body:any)
  {
    const WebUrl=this.postUrl+'CloudCollabo/ReactivateUser';
    return this.postdata(WebUrl, body);
  }

  UpdateLocations(body: any) {
    const Weburl = this.postUrl + 'CloudCollabo/Updatelocation';
    return this.postdata(Weburl, body);
  }
  UpdateCollaboStatus(body: any) {
    const Weburl = this.postUrl + 'CloudCollabo/UpdateCollaboStatus';
    return this.postdata(Weburl, body);
  }

  DeletechatGroup(body:any)
  {
    const WebUrl=this.postUrl+'CloudCollabo/DeleteChatgroup';
    return this.postdata(WebUrl, body);
  }

 DeleteLocations(body){
    const Weburl=this.postUrl + 'CloudCollabo/Deletelocation';
    return this.postdata(Weburl, body);
  }
  DeleteProposalbid(body){
    const Weburl=this.postUrl + 'CloudCollabo/DeleteProposalbid';
    return this.postdata(Weburl, body);
  }
  DeleteRoles(body){
  const Weburl=this.postUrl + 'CloudCollabo/DeleteRoles';
  return this.postdata(Weburl, body);
}
  GetSkills(){
    const Weburl = this.postUrl + 'CloudCollabo/Getskills';
    return this.FetchData(Weburl);
  
  }
  SaveSkills(body: any) {
    const Weburl = this.postUrl + 'CloudCollabo/Insertskills';
    return this.postdata(Weburl, body);
  }
  SaveServicecharge(body:any)
  {
    const Weburl = this.postUrl + 'CloudCollabo/Insertservicecharge';
    return this.postdata(Weburl, body);
  }
  DeleteServicecharge(body){
    const Weburl=this.postUrl + 'CloudCollabo/Deleteservicecharge';
    return this.postdata(Weburl,body);
  }
  DeleteSkill(body){
    const Weburl=this.postUrl + 'CloudCollabo/Deleteskills';
    return this.postdata(Weburl,body);
  }
SaveCategories(body:any)
  {
    const Weburl=this.postUrl+'CloudCollabo/Insertcategories';
    return this.postdata(Weburl,body);
  }
  GetCategories(usertype,pid)
  {
    const WebUrl=this.postUrl+'CloudCollabo/GetCategories?usertype='+usertype+'&parentidparm='+pid;
    return this.FetchData(WebUrl);
  }
  GetSubcategories()
  {
    const WebUrl=this.postUrl+'CloudCollabo/GetSubcategories';
    return this.FetchData(WebUrl);
  }
  DeleteCollabos(id,isactive)
  {
    const WebUrl=this.postUrl+'CloudCollabo/DeleteCollabos?id='+id+'&isactive='+isactive;
    return this.FetchData(WebUrl);
  }
 

 SaveRegionSkills(body:any){
    const Weburl=this.postUrl+'ProfileSetup/SaveRegionSkills';
    return this.postdata(Weburl,body);
  }
  GetRegionSkills(){
    const Weburl = this.postUrl + 'ProfileSetup/GetRegionSkills';
    return this.FetchData(Weburl);
  
  }
  SaveWorkExperience(body:any){
    const Weburl=this.postUrl+'ProfileSetup/Saveworkexperince';
    return this.postdata(Weburl,body);
  }
  GetWorkExperience(){
    const Weburl = this.postUrl + 'ProfileSetup/GetWorkExperience';
    return this.FetchData(Weburl);
  
  }
  SaveLegalDocuments(body:any){
    const Weburl=this.postUrl+'ProfileSetup/Savelegaldocuments';
    return this.postdata(Weburl,body);
  }
  GetLegalDocuments(){
    const Weburl = this.postUrl + 'ProfileSetup/GetLegalDocuments';
    return this.FetchData(Weburl);
  
  }
  SaveEducation(body:any){
    const Weburl=this.postUrl+'ProfileSetup/Saveeduction';
    return this.postdata(Weburl,body);
  }
  GetEducation(){
    const Weburl = this.postUrl + 'ProfileSetup/GetEducation';
    return this.FetchData(Weburl);
  
  }
  SaveCertification(body:any){
    const Weburl=this.postUrl+'ProfileSetup/Savecertification';
    return this.postdata(Weburl,body);
  }
  GetCertification(){
    const Weburl = this.postUrl + 'ProfileSetup/GetCertification';
    return this.FetchData(Weburl);
  
  }
  SavePortfolio(body:any){
    const Weburl=this.postUrl+'ProfileSetup/Saveportfolio';
    return this.postdata(Weburl,body);
  }
  GetPortfolio(){
    const Weburl = this.postUrl + 'ProfileSetup/GetPortfolio';
    return this.FetchData(Weburl);
  
  }
InsertActors(body:any){
  const Weburl=this.postUrl+'CloudCollabo/InsertActors';
  return this.postdata(Weburl,body);
}
 

  GetActors(){
  
    const WebUrl=this.postUrl+'CloudCollabo/GetActors';
    return this.FetchData(WebUrl);
    
  }
  GetSubscriptions(){
  
    const WebUrl=this.postUrl+'CloudCollabo/GetSubscriptions';
    return this.FetchData(WebUrl);
    
  }
  GetCountries(){
  
    const WebUrl=this.postUrl+'CloudCollabo/GetCountries';
    return this.FetchData(WebUrl);
    
  }
  GetStates(){
  
    const WebUrl=this.postUrl+'CloudCollabo/GetStates';
    return this.FetchData(WebUrl);
    
  }
  GetCities(){
  
    const WebUrl=this.postUrl+'CloudCollabo/GetCities';
    return this.FetchData(WebUrl);
    
  }
  GetCurrencies(){
  
    const WebUrl=this.postUrl+'CloudCollabo/GetCurrencies';
    return this.FetchData(WebUrl);
    
  }


  SaveCollabos(body:any)
  {
    
    const Weburl=this.postUrl+'CloudCollabo/InsertCollabo';
    return this.postdata(Weburl,body);
  }
  SavePraposalBids(body:any)
  {
    
    const Weburl=this.postUrl+'CloudCollabo/InsertPraposalBids';
    return this.postdata(Weburl,body);
  }
  changebidstatus(id,bidstatus)
{
  const WebUrl=this.postUrl+'CloudCollabo/changebidstatus?id='+id+'&bidstatus='+bidstatus;;
  return this.FetchData(WebUrl);
}

changenoofactors(NoOfActors,rowid)
{
  const WebUrl=this.postUrl+'CloudCollabo/changenoofactors?noofactors='+NoOfActors+'&id='+rowid;;
  return this.FetchData(WebUrl);
}


  GetCollabos(usertype)
  {
    const WebUrl=this.postUrl+'CloudCollabo/GetCollabos?usertype='+usertype;
    return this.FetchData(WebUrl);
  }
  GetStatus()
  {
    const WebUrl=this.postUrl+'CloudCollabo/GetStatus';
    return this.FetchData(WebUrl);
  }
  GetPraposalBids(){
    const WebUrl=this.postUrl+'CloudCollabo/GetPraposalBids';
    return this.FetchData(WebUrl);
  }

  GetCollaboActorDetails(){
    const WebUrl=this.postUrl+'CloudCollabo/GetCollaboActorDetails';
    return this.FetchData(WebUrl);
  }
  SaveHiringCollabarators(body:any)
  {
    
    const Weburl=this.postUrl+'CloudCollabo/InsertHiringCollabarator';
    return this.postdata(Weburl,body);
  }
  SaveInvoices(body:any)
  {
    
    const Weburl=this.postUrl+'CloudCollabo/InsertInvoices';
    return this.postdata(Weburl,body);
  }
  
  
  GetHiredCollabarators(){
    const WebUrl=this.postUrl+'CloudCollabo/GetHiredCollabarators';
    
    return this.FetchData(WebUrl);
  } 

  
  SaveChatRoomByUserID(body:any)
  {
    
    const Weburl=this.postUrl+'CloudCollabo/InsertChatRoom';
    return this.postdata(Weburl,body);
  }

  
  GetChatRooms(){
    const WebUrl=this.postUrl+'CloudCollabo/GetChatRooms';
    
    return this.FetchData(WebUrl);
  } 
  SaveChatMessages(body:any)
  {
    
    const Weburl=this.postUrl+'CloudCollabo/InsertChatMessages';
    return this.postdata(Weburl,body);
  }

  
  GetChatMessages(){
    const WebUrl=this.postUrl+'CloudCollabo/GetChatMessages';
    
    return this.FetchData(WebUrl);
  } 

  InsertchatGroup(body: any) {
    const Weburl = this.postUrl + 'CloudCollabo/Insertchatgroup';
    return this.postdata(Weburl, body);
}
GetchatGroup(){
  const WebUrl=this.postUrl+'CloudCollabo/Getchartgroup';
    return this.FetchData(WebUrl);
} 
InsertchatuserGroup(body: any) {
  const Weburl = this.postUrl + 'CloudCollabo/Insertchatusergroup';
  return this.postdata(Weburl,body);
}
GetchatuserGroup(){
const WebUrl=this.postUrl+'CloudCollabo/Getchatusergroup';
  return this.FetchData(WebUrl);
} 


SaveUserRole(body: any) {
  const Weburl = this.postUrl + 'CloudCollabo/SaveUserRole';
  return this.postdata(Weburl, body);
}
SaveRole(body: any) {
  const Weburl = this.postUrl + 'CloudCollabo/SaveRole';
  return this.postdata(Weburl, body);
}


GetRoles(usertype){
  const WebUrl=this.postUrl+'CloudCollabo/GetRoles?usertype='+usertype;
    return this.FetchData(WebUrl);
  } 
uploadPhoto(file):Observable<any> {
{
  const Weburl = this.postUrl +'CloudCollabo/Insertphoto';
  return this.postdata(Weburl,file);
  let headers = new Headers();
  headers.append('Content-Type', 'multipart/form-data');
  headers.append('Accept', 'application/json');
  let formData = new FormData();
  formData.append('upload', file);
  let params = new HttpParams();
  const options = {
    params: params,
    reportProgress: true,
  };
  const req = new HttpRequest('POST',Weburl, formData, options);
  return this.http1.request(req);
}
}
filechange2(input,length,userid,filetype){
  var param=filetype
  const reader = new FileReader();
  if (length) {
    
    const file = input;
    reader.onload = () => {
      this.imagefile1 = reader.result;
    }
    reader.readAsDataURL(file);
    var selectedFile = file;
    var idxDot = selectedFile.name.lastIndexOf(".") + 1;
    var extFile = selectedFile.name.substr(idxDot, selectedFile.name.length).toLowerCase();
    if(userid==""){
    if (extFile.toLowerCase()=="pdf" || extFile.toLowerCase()=='doc'||extFile.toLowerCase()=="png" || extFile.toLowerCase()=='jpeg' || extFile.toLowerCase()=="jpg") {
      var UploadFile1 = new FormData();
      UploadFile1.append("PostedFile", file);
      const url = this.postUrl + 'CloudCollabo/UploadImage?param='+param+'&userid='+userid;
      this._http.post(url, UploadFile1).subscribe((data: any) => {
        if (data != null) {
        
          this.imagefile="";
          this.imagefile1 = JSON.parse(data._body);
          this.pathData = JSON.parse(data._body);
          this.uploadPathData = JSON.parse(data._body);
          this.imageservice.ImageUploader1(this.imagefile1);
        }
      });
    
    }
    else {
      alert("Only pdf,doc files are allowed!");

      
    }
  }
  else{
    if (extFile.toLowerCase()=="png" || extFile.toLowerCase()=='jpeg' || extFile.toLowerCase()=="jpg"||extFile.toLowerCase()=="pdf" || extFile.toLowerCase()=='doc') {
      var UploadFile = new FormData();
      UploadFile.append("PostedFile", file);
      const url = this.postUrl + 'CloudCollabo/UploadImage?param='+param+'&userid='+userid;
      this._http.post(url, UploadFile).subscribe((data: any) => {
        if (data != null) {
          this.imagefile="";
          this.imagefile1 = JSON.parse(data._body);
          this.pathData = JSON.parse(data._body);
          this.uploadPathData = JSON.parse(data._body);
          this.imageservice.ImageUploader1(this.imagefile1);
        }
      });
    
    }
    else {
      alert("Only png,jpeg files are allowed!");
    }
  }
  }
  
}
filechange1(input,param,userid){
  const reader = new FileReader();
  if (input.files.length) {
    
    const file = input.files[0];
    reader.onload = () => {
      this.imagefile1 = reader.result;
      this.imagefile2 = reader.result;
    }
    reader.readAsDataURL(file);
    var selectedFile = file;
    var idxDot = selectedFile.name.lastIndexOf(".") + 1;
    var extFile = selectedFile.name.substr(idxDot, selectedFile.name.length).toLowerCase();
    if(userid==""){
    if (extFile.toLowerCase()=="pdf" || extFile.toLowerCase()=='doc'||extFile.toLowerCase()=="png" || extFile.toLowerCase()=='jpeg' || extFile.toLowerCase()=="jpg") {
      var UploadFile = new FormData();
      UploadFile.append("PostedFile", file);
      const url = this.postUrl + 'CloudCollabo/UploadImage?param='+param+'&userid='+userid;
      this._http.post(url, UploadFile).subscribe((data: any) => {
        if (data != null) {
          this.imagefile="";
          this.imagefile1 = JSON.parse(data._body);
          this.imagefile2 = JSON.parse(data._body);
          this.pathData = JSON.parse(data._body);
          this.uploadPathData = JSON.parse(data._body);
          this.imageservice.ImageUploader1(this.imagefile1);
          this.imageservice.ImageUploader2(this.imagefile2);
        }
      });
    }
    else {
      alert("Only pdf,doc files are allowed!");
    }
  }
  else{
    if (extFile.toLowerCase()=="png" || extFile.toLowerCase()=='jpeg' || extFile.toLowerCase()=="jpg"||extFile.toLowerCase()=="pdf" || extFile.toLowerCase()=='doc') {
      var UploadFile = new FormData();
      UploadFile.append("PostedFile", file);
      const url = this.postUrl + 'CloudCollabo/UploadImage?param='+param+'&userid='+userid;
      this._http.post(url, UploadFile).subscribe((data: any) => {
        if (data != null) {
          this.imagefile="";
          this.imagefile1 = JSON.parse(data._body);
          this.pathData = JSON.parse(data._body);
          this.uploadPathData = JSON.parse(data._body);
          this.imageservice.ImageUploader1(this.imagefile1);
          this.imageservice.ImageUploader2(this.imagefile2);
        }
      });
    }
    else {
      alert("Only png,jpeg files are allowed!");
    }
  }
  }
  
}

filechange(input,param,userid){
  const reader = new FileReader();
  if (input.files.length) {
    
    const file = input.files[0];
    reader.onload = () => {
      this.imagefile1 = reader.result;
      this.imagefile2 = reader.result;
    }
    reader.readAsDataURL(file);
    var selectedFile = file;
    var idxDot = selectedFile.name.lastIndexOf(".") + 1;
    var extFile = selectedFile.name.substr(idxDot, selectedFile.name.length).toLowerCase();
    if(userid!=""){
    if (extFile.toLowerCase()=="pdf" || extFile.toLowerCase()=='doc'||extFile.toLowerCase()=="png" || extFile.toLowerCase()=='jpeg' || extFile.toLowerCase()=="jpg") {
      var UploadFile = new FormData();
      UploadFile.append("PostedFile", file);
      const url = this.postUrl + 'CloudCollabo/UploadImage?param='+param+'&userid='+userid;
      this._http.post(url, UploadFile).subscribe((data: any) => {
        if (data != null) {
          this.imagefile="";
          this.imagefile1 = JSON.parse(data._body);
          this.pathData = JSON.parse(data._body);
          this.uploadPathData = JSON.parse(data._body);
          this.imageservice.ImageUploader(this.imagefile1);
          this.imageservice.ImageUploader1(this.imagefile1);
        }
      });
    }
    else {
      alert("Only pdf,doc files are allowed!");
    }
  }
  else{
    if (extFile.toLowerCase()=="png" || extFile.toLowerCase()=='jpeg' || extFile.toLowerCase()=="jpg"||extFile.toLowerCase()=="pdf" || extFile.toLowerCase()=='doc') {
      var UploadFile = new FormData();
      UploadFile.append("PostedFile", file);
      const url = this.postUrl + 'CloudCollabo/UploadImage?param='+param+'&userid='+userid;
      this._http.post(url, UploadFile).subscribe((data: any) => {
        if (data != null) {
          this.imagefile="";
          this.imagefile1 = JSON.parse(data._body);
          this.pathData = JSON.parse(data._body);
          this.uploadPathData = JSON.parse(data._body);
          this.imageservice.ImageUploader1(this.imagefile1);
        }
      });
    }
    else {
      alert("Only png,jpeg files are allowed!");
    }
  }
  }
  
}
showSuccess(message, title){
  this.toastr.success(message, title,{
    positionClass:'toast-top-right'
  })
}

showError(message, title){
  this.toastr.error(message, title,{
    positionClass:'toast-top-right  '
  })
}

showInfo(message, title){
  this.toastr.info(message, title,{
    positionClass:'toast-top-right'
  })
}
Deletecategory(body:any)
  {
    const WebUrl=this.postUrl+'CloudCollabo/Deletecategorie';
    return this.postdata(WebUrl, body);
  }

showWarning(message, title){
  this.toastr.warning(message, title,{
    positionClass:'toast-top-right'
  })
}

  
Getcms(usertype){
  const Weburl = this.postUrl + 'CloudCollabo/Getcms?usertype='+usertype;
  return this.FetchData(Weburl);

}
SaveCMS(body: any) {
  const Weburl = this.postUrl + 'CloudCollabo/SaveCMS';
  return this.postdata(Weburl, body);
}
DeleteCMS(id,isactive)
{
  const WebUrl=this.postUrl+'CloudCollabo/DeleteCMS?id='+id+'&isactive='+isactive;;
  return this.FetchData(WebUrl);
}

GetInvoices(){
  const Weburl = this.postUrl + 'CloudCollabo/GetInvoices';
  return this.FetchData(Weburl);
}
GetNotifications(){
  const Weburl = this.postUrl + 'CloudCollabo/GetNotifications';
  return this.FetchData(Weburl);

}


}

